import script from "./DrawerFacade.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerFacade.vue?vue&type=script&setup=true&lang=js"

import "./DrawerFacade.vue?vue&type=style&index=0&id=c147fe58&lang=scss"

const __exports__ = script;

export default __exports__